export default __webpack_public_path__ + "static/media/featureditems_two.449d6ce2.png";